module.exports = __webpack_public_path__ + "img/pm_3.bebe97cd.png";